<div class="bg-white border m-2 py-3 px-3 shadow-sm">
  <h5>Front desk</h5>
  <era-device-link-selector [selection]="selection$ | async"
                            [isSpare]="false"
                            [isFrontDesk]="true"
                            (selectionChange)="updateSelection($event)">
  </era-device-link-selector>
  <button type="submit"
          class="btn btn-success me-2"
          (click)="frontDesk()">Front desk</button>
  <a type="cancel"
     class="btn btn-outline-primary"
     [routerLink]="['../']">Cancel</a>
</div>